import { Check } from "@phosphor-icons/react";

const ORDER = ["Approved", "Template", "Fabrication", "Install", "Complete"];
const STAGE_RANK = { Lead: -1, Quoted: 0 };

const fmt = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric" }) : "";

const earliest = (list) => list.filter(Boolean).sort()[0] || "";

export const ProjectTimeline = ({ p }) => {
  const quotes = p.quotes || [];
  const jobs = (p.jobs || []).filter((j) => !j.archived);
  const steps = [
    { key: "quote", label: "Quote", date: earliest(quotes.map((q) => q.created_at)), stage: "Quoted" },
    { key: "accepted", label: "Accepted", date: earliest(quotes.map((q) => q.accepted_at)), stage: "Approved" },
    { key: "template", label: "Template", date: earliest(jobs.map((j) => j.template_date)) || p.target_template_date, stage: "Template" },
    { key: "fab", label: "Fabrication", date: earliest(jobs.map((j) => j.fab_date)), stage: "Fabrication" },
    { key: "install", label: "Install", date: earliest(jobs.map((j) => j.install_date)) || p.target_install_date, stage: "Install" },
  ];
  const rank = (s) => (s in STAGE_RANK ? STAGE_RANK[s] : ORDER.indexOf(s) + 1);
  const cur = rank(p.stage || "Lead");
  const today = new Date().toISOString().slice(0, 10);
  return (
    <section
      data-testid="project-timeline"
      className="rounded-lg border border-zinc-800 bg-zinc-900 px-4 py-3"
    >
      <ol className="flex items-start">
        {steps.map((s, i) => {
          const r = rank(s.stage);
          const done = cur > r || (cur === r && s.key === "quote");
          const active = cur === r;
          const late = !done && s.date && s.date.slice(0, 10) < today;
          return (
            <li
              key={s.key}
              data-testid={`timeline-${s.key}`}
              data-state={done ? "done" : active ? "active" : "pending"}
              className="relative flex flex-1 flex-col items-center text-center"
            >
              {i > 0 && (
                <span
                  className={`absolute right-1/2 top-[9px] h-px w-full ${done || active ? "bg-emerald-500/60" : "bg-zinc-800"}`}
                />
              )}
              <span
                className={`relative z-10 flex h-[18px] w-[18px] items-center justify-center rounded-full border-2 transition-colors duration-200 ${
                  done
                    ? "border-emerald-500 bg-emerald-500 text-zinc-950"
                    : active
                      ? "border-indigo-400 bg-zinc-900 shadow-[0_0_0_4px_rgba(129,140,248,0.2)]"
                      : "border-zinc-700 bg-zinc-900"
                }`}
              >
                {done && <Check size={11} weight="bold" />}
              </span>
              <span
                className={`mt-2 text-[10px] font-bold uppercase tracking-widest ${
                  active ? "text-indigo-200" : done ? "text-zinc-300" : "text-zinc-600"
                }`}
              >
                {s.label}
              </span>
              <span
                data-testid={`timeline-${s.key}-date`}
                className={`mt-0.5 text-[11px] ${late ? "text-amber-300" : s.date ? "text-zinc-400" : "text-zinc-700"}`}
              >
                {fmt(s.date) || "—"}
              </span>
            </li>
          );
        })}
      </ol>
    </section>
  );
};
